module.exports = __webpack_public_path__ + "static/miljo4-1ea12a4b066a763bd481e1c3f9326a61.jpg";